<template>
  <div class="main_body home_page">

    <!-- header section starts -->
    <section id="hero_section">
      <div class="container">
        <navbar></navbar>

        <div class="main_logo">
          <img src="@/assets/images/Logo-011.png" alt="Logo-011.png">
        </div>

        <!-- youtube starts -->
        <section class="youtube_section">
          <!-- subscribe box -->
          <youtube-banner :type="'homepage'"></youtube-banner>

          <!-- latest music list -->
          <latest-music :showHeading="true"></latest-music>

        </section>
        <!-- youtube ends -->
      </div>
    </section>
    <!-- header section ends -->

    <!-- social section starts -->
    <also-available-on />
    <!-- available section ends -->

    <homepage-banners></homepage-banners>

    <spotify-playlist></spotify-playlist>

    <!-- middle bg section starts  -->
    <blogs></blogs>

    <!-- middle section ends -->
    <section class="bottom_bg_wrapper">
      <twitter-feed></twitter-feed>
      <div class="container">
        <social-links />
      </div>
      <!-- <instagram-feed></instagram-feed> -->
    </section>
  </div>
</template>

<script>
import SpotifyPlaylist from '../components/SpotifyPlaylist.vue'
import TwitterFeed from '../components/TwitterFeed.vue'
import Blogs from '../components/Blogs.vue'
import HomepageBanners from '../components/HomepageBanners.vue'
import LatestMusic from '@/components/LatestMusic'
import YoutubeBanner from '../components/YoutubeBanner.vue'
import SocialLinks from '../components/SocialLinks.vue'
import AlsoAvailableOn from '../components/AlsoAvailableOn.vue'

// import InstagramFeed from '../components/InstagramFeed.vue'
export default {
  name: 'Home',
  components: {
    SpotifyPlaylist,
    TwitterFeed,
    Blogs,
    HomepageBanners,
    LatestMusic,
    YoutubeBanner,
    SocialLinks,
    AlsoAvailableOn
  },
  data () {
    return {}
  }
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Home.vue